import { Dialog, DialogTitle, DialogContent, Box, Button, CircularProgress } from '@mui/material';
import * as mammoth from 'mammoth';
import React, { useEffect, useState } from 'react';

export default function FilePreviewDialog({ open, onClose, url, name }) {
  const [txtContent, setTxtContent] = useState('');
  const [txtLoading, setTxtLoading] = useState(false);
  const [docxHtml, setDocxHtml] = useState('');
  const [docxLoading, setDocxLoading] = useState(false);

  useEffect(() => {
    if (open && url && name && name.match(/\.txt$/i)) {
      setTxtLoading(true);
      fetch(url)
        .then((resp) => resp.text())
        .then((text) => setTxtContent(text))
        .catch(() => setTxtContent('Ошибка загрузки файла'))
        .finally(() => setTxtLoading(false));
    } else {
      setTxtContent('');
      setTxtLoading(false);
    }
  }, [open, url, name]);

  useEffect(() => {
    if (open && url && name && name.match(/\.docx$/i)) {
      setDocxLoading(true);
      fetch(url)
        .then((resp) => resp.arrayBuffer())
        .then((arrayBuffer) => mammoth.convertToHtml({ arrayBuffer }))
        .then((result) => setDocxHtml(result.value))
        .catch(() => setDocxHtml('Ошибка загрузки файла'))
        .finally(() => setDocxLoading(false));
    } else {
      setDocxHtml('');
      setDocxLoading(false);
    }
  }, [open, url, name]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span>{name}</span>
        {url && (
          <Button
            variant="outlined"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{ ml: 2 }}
          >
            Скачать файл
          </Button>
        )}
      </DialogTitle>
      <DialogContent>
        {(() => {
          if (!url || !name) return null;
          const ext = name.split('.').pop().toLowerCase();
          switch (ext) {
            case 'pdf':
              return (
                <Box sx={{ height: '600px' }}>
                  <iframe
                    src={`${url}#toolbar=0&navpanes=0&scrollbar=0`}
                    width="100%"
                    height="100%"
                    title={name}
                    style={{ border: 'none' }}
                  />
                </Box>
              );
            case 'docx':
              return docxLoading ? (
                <CircularProgress />
              ) : (
                <Box sx={{ maxHeight: '600px', overflow: 'auto', background: '#fff', p: 2 }}>
                  <div dangerouslySetInnerHTML={{ __html: docxHtml }} />
                </Box>
              );
            case 'txt':
              return txtLoading ? (
                <CircularProgress />
              ) : (
                <Box sx={{ maxHeight: '600px', overflow: 'auto', background: '#f5f5f5', p: 2 }}>
                  <pre style={{ fontFamily: 'monospace', margin: 0 }}>{txtContent}</pre>
                </Box>
              );
            case 'doc':
              return null;
            default:
              return null;
          }
        })()}
      </DialogContent>
    </Dialog>
  );
}
